import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MedicalTestRequestService } from 'src/app/_services/medical-test-request/medical-test-request.service';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';
import {
  ITestRequestDetails, IPaymentInformation,
  IInvoiceInformation
} from 'src/app/_interfaces/patients/i-test-request-details';
import { ChannelTypeEnum } from 'src/app/enums/channel-type.enum';
import { UploadMultipleFilesModalComponent } from '@components/upload-multiple-files-modal/upload-multiple-files-modal.component';
import { PrescriptionSourceTypeEnum } from 'src/app/enums/prescription-source-type.enum';
import { IEhrTestRequestInformationDTO, IEhrTestRequestLocationDTO, IFileDTO, IMedicalTestDetailDTO, IMedicalTestDetails, IMedicalTestRequestDetailsDTO, IPatientPersonalDetailsDTO } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { IFile } from 'src/app/_interfaces/files/i-files';
import { TestTypes } from 'src/app/enums/test-coupon-enums';
import { TestRequestService } from 'src/app/_services/test-request.service';
import { isPdfFile } from 'src/app/helpers/check-file-type';

@Component({
  selector: 'app-test-request-details',
  templateUrl: './test-request-details.component.html',
  styleUrls: ['./test-request-details.component.scss'],
})
export class TestRequestDetailsComponent implements OnInit {
  ehrTransactionId;
  emrDiscriminator;
  testRequestDetails: ITestRequestDetails;
  medicalTestDetails: IMedicalTestDetails;
  patientPersonalDetails: IPatientPersonalDetailsDTO;
  testRequestInformation: IEhrTestRequestInformationDTO;
  testRequestPlace: IEhrTestRequestLocationDTO;
  medicalTests: IMedicalTestDetailDTO;
  radiologies: IMedicalTestDetailDTO;
  physiotherapies: string[];
  paymentInformation: IPaymentInformation;
  invoice: IInvoiceInformation;
  modalRef: BsModalRef;
  sourceType;
  medicalTestFiles: string[];
  medicalTestFilesAsPdf: string[] = [];
  medicalTestFilesAsImages: string[] = [];

  constructor(
    private medicalTestRequestService: MedicalTestRequestService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private testRequestService: TestRequestService
  ) { }

  ngOnInit(): void {
    this.ehrTransactionId = this.activatedRoute.snapshot.queryParams.medicalTestId;
    this.sourceType = this.activatedRoute.snapshot.queryParams.sourceType;

    if (this.sourceType == PrescriptionSourceTypeEnum.details)
      this.getMedicalTestDetails(this.ehrTransactionId);
    else
      this.getMedicalTestFiles(this.ehrTransactionId)
  }

  get medicalTestSourceTypeEnum() {
    return PrescriptionSourceTypeEnum;
  }

  get channelTypeEnum() {
    return ChannelTypeEnum
  }

  getMedicalTestDetails(ehrTransactionId) {
    this.medicalTestRequestService
      .getMedicalTestDetails(ehrTransactionId)
      .subscribe((response) => {
        this.medicalTestDetails = response.data;
        this.patientPersonalDetails = this.medicalTestDetails?.patientPersonalDetails;
        this.testRequestInformation = this.medicalTestDetails?.testRequestInformation;
        this.testRequestPlace = this.medicalTestDetails?.testRequestLocation;
        this.medicalTests = this.medicalTestDetails?.medicalTests;
        this.radiologies = this.medicalTestDetails?.radiologies;
        this.physiotherapies = this.medicalTestDetails?.physiotherapies?.testRequestDetails?.map(p => p.test.name) || [];
        this.paymentInformation = this.medicalTestDetails?.paymentInformation;
        this.invoice = this.medicalTestDetails?.paymentInformation?.invoice;
      });
  }

  getMedicalTestFiles(ehrTransactionId) {
    this.medicalTestRequestService
      .getMedicalTestFiles(ehrTransactionId)
      .subscribe((response) => {
        this.medicalTestFiles = response.data?.filePaths;

        if (this.medicalTestFiles?.length) {
          this.medicalTestFiles.forEach((file) => {
            if (isPdfFile(file)) {
              this.medicalTestFilesAsPdf.push(file);
            } else {
              this.medicalTestFilesAsImages.push(file);
            }
          });
        }
      });
  }

  checkChannel() {
    if (this.testRequestInformation?.channel?.id == this.channelTypeEnum.application) {
      return 'Application';
    } else if (this.testRequestInformation?.channel?.id == this.channelTypeEnum.admin) {
      return 'Admin';
    } else if (this.testRequestInformation?.channel?.id == this.channelTypeEnum.portal) {
      return 'Portal';
    }

    return '--';
  }

  checkPromocode() {
    if (this.invoice?.promoCode) {
      return `(${this.invoice.promoCode})`;
    }

    return null;
  }

  onUploadTestResult(test: IMedicalTestRequestDetailsDTO, testRequestResults: IFileDTO[]) {
    let files: IFile[] = test?.resultFiles?.map(f => {
      return {
        id: f.id,
        path: f.path,
        isEditable: false,
      }
    }) || [];

    testRequestResults?.forEach(f => {
      files.push({
        id: f.id,
        path: f.path,
        isEditable: false,
      })
    })
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        test: test,
        testRequestId: this.ehrTransactionId,
        emrDiscriminator: this.emrDiscriminator,
        title: test.test.name + " Files",
        subtitle: `Please upload ${test.test.name} results below by dragging the file or clicking upload files.`,
        filesExisted: files
      },
    };

    this.modalRef = this.modalService.show(
      UploadMultipleFilesModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((response) => {
      // if(response.action === 'deleteFile'){
      //   //Will call method to delete file
      //
      // }

      if (response.action === 'uploadFiles') {
        this.uploadTestResultDetails(test.id, response.filesToUpload)
      }

      // if (response.message == 'uploaded') {
      //   test.results = 'Available';
      //   test.resultPath = response.resultPath;
      // }

      // if (response.message == 'deleted') {
      //   test.results = 'Not Available';
      //   test.resultPath = null;
      // }

      // if (this.medicalTests.length) {
      //   let isDone = this.medicalTests.every(
      //     (item) => item.results == 'Available'
      //   );

      //   if (isDone) {
      //     this.testRequestInformation.status = 'Done';
      //   } else {
      //     let isPartiallyDone = this.medicalTests.some(
      //       (item) => item.results == 'Available'
      //     );

      //     if (isPartiallyDone) {
      //       this.testRequestInformation.status = 'Partially Done';
      //     } else {
      //       this.testRequestInformation.status = 'Submitted';
      //     }
      //   }
      // }
    });
  }

  downloadFile(fileUrl) {
    this.medicalTestRequestService
      .downloadFile(fileUrl)
      .subscribe((response) => {
        let fileName = fileUrl.split('/').pop();
        let a = document.createElement('a');
        let objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  downloadTestRequestResults(testType: number) {
    if (testType == TestTypes.Lab) {
      if (this.medicalTests?.testRequestDetails?.some(t => t.resultFiles.length) || this.medicalTests?.testRequestResults?.length) {
        this.medicalTests.testRequestDetails?.forEach(t => t.resultFiles.forEach(f => this.downloadFile(f.path)));
        this.medicalTests.testRequestResults?.forEach(t => this.downloadFile(t.path));
      }
      else {
        showNotification('danger', 'There is no results to download!', this.toastr);
      }
    }
    else if (testType == TestTypes.Scan) {
      if (this.radiologies?.testRequestDetails?.some(t => t.resultFiles.length) || this.radiologies?.testRequestResults?.length) {
        this.radiologies.testRequestDetails?.forEach(t => t.resultFiles.forEach(f => this.downloadFile(f.path)));
        this.radiologies.testRequestResults?.forEach(t => this.downloadFile(t.path));
      }
      else {
        showNotification('danger', 'There is no results to download!', this.toastr);
      }
    }
  }

  uploadTestResultDetails(testRequestDetailsId, files) {
    this.testRequestService.uploadTestRequestDetailsResult(testRequestDetailsId, files)
      .subscribe(res => {
        if (res.data.flag) {
          showNotification('success', 'files are uploaded successfully', this.toastr);
          window.location.reload();
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
        this.modalRef.hide();
      });
  }

  generateQuickPaymentLink(): void {
    this
      .testRequestService
      .generatePaymobQuickPaymentLink(this.ehrTransactionId)
      .subscribe(res => {
        if (res.data.flag) {
          showNotification('success', 'Payment Link was generated successfully', this.toastr);
          window.location.reload();
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
      });
  }
}
